export default "__VITE_ASSET__4c82f3db__"